import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./GenerateFees.css";

export default function GenerateFees() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [month, setMonth] = useState("");
  const [amount, setAmount] = useState("");

  const MONTHS = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  // ================= LOAD CLASSES =================
  const loadClasses = async () => {
    const res = await API.get("/school-admin/classes/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setClasses(res.data.classes);
  };

  // ================= LOAD SECTIONS =================
  const loadSections = async (id) => {
    const res = await API.get(`/school-admin/sections/${id}/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setSections(res.data.sections);
  };

  useEffect(() => {
    loadClasses();
  }, []);

  // ================= COMMON VALIDATION =================
  const validate = () => {
    if (!classId) return alert("Select class");
    if (!sectionId) return alert("Select section");
    if (!month) return alert("Select month");
    if (!amount || amount <= 0) return alert("Enter valid amount");
    return true;
  };

  // ================= GENERATE =================
  const handleGenerate = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await API.post(
        "/school-admin/fees/generate/",
        { class_id: classId, section_id: sectionId, month, amount },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );

      alert("✅ Monthly fees generated");
    } catch (err) {
      alert("❌ Error generating fees");
    }
  };

  // ================= UPDATE =================
  const handleUpdate = async () => {
    if (!validate()) return;

    if (!window.confirm("Update fees for this month?")) return;

    try {
      await API.put(
        "/school-admin/fees/update-month/",
        { class_id: classId, section_id: sectionId, month, amount },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );

      alert("✏️ Fees updated successfully");
    } catch (err) {
      alert("❌ Error updating fees");
    }
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    if (!classId || !sectionId || !month) {
      return alert("Select class, section & month");
    }

    if (!window.confirm("⚠️ Delete ALL pending fees for this month?")) return;

    try {
      await API.delete("/school-admin/fees/delete-month/", {
        headers: { "X-SCHOOL-ID": school.school.id },
        data: { class_id: classId, section_id: sectionId, month },
      });

      alert("🗑️ Pending fees deleted");
    } catch (err) {
      alert("❌ Error deleting fees");
    }
  };

  // ================= UI =================
  return (
    <div className="generate-fees-container">
      <h2>Monthly Fees Management</h2>

      <form className="generate-fees-form" onSubmit={handleGenerate}>

        {/* CLASS */}
        <label>Class</label>
        <select
          value={classId}
          onChange={(e) => {
            setClassId(e.target.value);
            loadSections(e.target.value);
          }}
        >
          <option value="">Select Class</option>
          {classes.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>

        {/* SECTION */}
        <label>Section</label>
        <select value={sectionId} onChange={(e) => setSectionId(e.target.value)}>
          <option value="">Select Section</option>
          {sections.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

        {/* MONTH */}
        <label>Month</label>
        <select value={month} onChange={(e) => setMonth(e.target.value)}>
          <option value="">Select Month</option>
          {MONTHS.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        {/* AMOUNT */}
        <label>Fees Amount</label>
        <input
          type="number"
          value={amount}
          placeholder="Enter amount"
          onChange={(e) => setAmount(e.target.value)}
        />

        {/* ACTION BUTTONS */}
        <div className="fee-actions">
          <button type="submit" className="btn-generate">Generate</button>
         
        </div>
      </form>
    </div>
  );
}
